import * as React from 'react';

import { getAvailableRoutes } from '@/app/route-registry';
import { usePluginStatus } from '@/hooks/use-plugin-status';

/** Resolves the route registry against the current plugin state. */
export function useAppRoutes() {
  const { plugins } = usePluginStatus();

  // Role-based filtering is no longer driven by the hardcoded session role.
  // All routes in the registry use requiredPlugin (not requiredRole), so
  // passing undefined is correct — staff role enforcement happens via
  // RequireStaff / RequireAdmin route guards.
  return React.useMemo(() => getAvailableRoutes(plugins, undefined), [plugins]);
}
